'use strict'

import EventUtils from "./utils/eventUtils";
import tools from "./utils/fun";
import eventConfig from "./baseConfig/eventConfig";
import ServerManager from "./interface/server";
import AnalystManager from "./utils/analyst";

var AppTools = {};

/**
 * 确认是否存在在先游戏 【注：初始化的时候执行一次】
 * @param {*} self 
 */
AppTools.checkIsInGame = function(self){
    ServerManager.isContinueGame(self, (data) => {
        if (data) {
            if (data.config) {
                self.showToGameMessageBox(data.config);
            }
            if (data.money != null) {
                self.$store.commit("user/setMoney", data.money);
                //延迟更新账户余额
                tools.asyncEvent(() => {
                    tools.emit(eventConfig.REFRESH_MONEY);
                }, 500);
            }
        }
    });
    //AF 登录上报
    window.AndroidBridge && window.AndroidBridge.afLogin && window.AndroidBridge.afLogin();
}

/**
 * 更新用户信息和状态
 * @param {*} self 
 */
AppTools.setActionByFreshUser = function(self){
    return new Promise(function(resolve , reject){
        ServerManager.refreshUser(self, true, () => { resolve(self); } , () => { reject(); } ); 
    });   
}

AppTools.setInitData = function(self){
    if (document.referrer && document.referrer.indexOf(".rummy.cool") != -1) {
        return new Promise(function(resolve , reject){
            tools.asyncEvent(() => { resolve(self); } , 3000);
        });
    } else {
        return new Promise(function(resolve , reject){
            resolve(self);
        });
    }
}

/**
 * 进入游戏
 */
AppTools.toGame = function(self , info) {
    tools.setLoadingState(true);
    ServerManager.getGameUrl(
        self,
        info.gameId,
        info.roomId,
        info.isDemo,
        (data) => {
            setTimeout(() => {
                window.location.href = data.loginUrl + "&isBack=1";
            }, 1000);
            //进入游戏，清理预充值标记，避免统计错误
            self.$store && self.$store.commit("user/setPayMoney" , 0);
            //进入游戏成功
            AnalystManager.event(
                self,
                eventConfig.google.home.EVENT,
                eventConfig.google.home.CONTINUE,
                info.roomId
            );
        },
        (err) => {
            tools.setLoadingState(false);
            self.$toast.show(err);
        }
    );
}

/**
 * app sports 联合登录参数
 * @param {*} self 
 */
AppTools.setjumpBangbet = function(self) {
    if (!window.AndroidBridge) {
        return;
    }
    let user = self.$store.state.user;
    if (!user) {
        return;
    } 
    //通知android 登陆的token 和 scret , 联合登录使用
    if (user.isLogin && window.AndroidBridge.jumpToBet) {
        let token = user.realUser.token;
        let secretKey = user.realUser.secretKey;
        let updata = {
            secretKey: secretKey,
            token: token,
        };
        window.AndroidBridge.jumpToBet(JSON.stringify(updata));
    }
}

/**
 * 获得gaid 
 */
AppTools.getGaid = function(self) {
    if (!window.gaid) {
        window.gaid = window.localStorage.getItem("casino-gaid");
    }
    if (!window.gaid && window.AndroidBridge.getGaid) {
        let gaid = window.AndroidBridge.getGaid();
        if (gaid && gaid != "") {
            window.localStorage.setItem("casino-gaid", gaid);
            window.gaid = gaid;
        }
    }
    self.setTestMessage("step2:gaid=" + window.gaid + "|");
}

/**
 * 获得版本号
 */
AppTools.getLiteVersion = function(self) {
    if (!window.liteVer) {
        window.liteVer = "1.0";
        if (window.AndroidBridge.getVersionCode) {
            window.liteVer = window.AndroidBridge.getVersionCode();
        }
        self.setTestMessage(
            "step3:liteVer=" + window.liteVer + "|"
        );
    }
}

//设置内部跳转地址根域名
AppTools.setFilter = function(self) {
    if (window.AndroidBridge.setFilterUrl) {
        window.AndroidBridge.setFilterUrl(
            tools.getRemoteResourceRoot()
        );
        window.AndroidBridge.setFilterUrl(".rummy.cool/");
        window.AndroidBridge.setFilterUrl(".ez-pay.in/");
        self.setTestMessage("step4:filter|");
    }
}


//充值firebase token
AppTools.resetFirebaseToken = function(self) {
    let fcmData = {
        fcmToken: "",
        uuid: null,
    };
    let sUser = self.$store.state.user;
    if (!sUser) {
        return fcmData;
    }
    fcmData.uid = sUser.isLogin ? sUser.realUser.id : 0;
    if (window.AndroidBridge.getFCMToken) {
        var jdStr = window.AndroidBridge.getFCMToken();
        if (jdStr && jdStr.indexOf("mToken") != -1) {
            let jd = JSON.parse(jdStr);
            fcmData.fcmToken = jd.mToken;
            fcmData.uuid = jd.mUuID;
            if (fcmData.uuid && fcmData.uuid.length > 16) {
                window.localStorage.setItem(
                    "unique-udid",
                    fcmData.uuid
                );
            }
        }
        if (!fcmData.fcmToken && window.AndroidBridge.getfcmToken) {
            fcmData.fcmToken = window.AndroidBridge.getfcmToken();
        }
        if (!fcmData.fcmToken) fcmData.fcmToken = "";
    }
    let str = (fcmData.fcmToken && fcmData.fcmToken != "") ? "success" : "failure";
    self.setTestMessage("step6:getFCMToken" + str + "|");
    return fcmData;
}

export default AppTools;


// WEBPACK FOOTER //
// ./src/app_tools.js